export enum DialogType {
  AffiliateLockedRewards = "ShowAffiliateLockedRewards",
  AffiliateLockedVipRewards = "ShowAffiliateLockedVipRewards",
  AffiliateCommissionHistory = "ShowAffiliateCommissionHistory",
  AffiliateInvitationChest = "ShowAffiliateInvitationChest",
  Salesforce = "ShowSalesforce",
  AffiliateShare = "ShowAffiliateShare",
  TeamExplain = "ShowTeamExplain",
  TeamDetails = "ShowTeamDetails",
  TeamInvitee = "ShowTeamInvitee",
  Tips = "ShowTips",
  SwitchLanguage = "ShowSwitchLanguage",
  ChangeInfo = "ShowChangeInfo",
  VerifyCode = "ShowVerifyCode",
  NoCodeReceived = "ShowNoCodeReceived", // settings > security > change email > 没有收到验证码
  PersonalInfo = "ShowPersonalInfo", // settings > verify > personal info
  // 流水
  BillFlow = "ShowBillFlow",
  // 流水详情
  BillFlowDetail = "ShowBillFlowDetail",
  BindDefaultPoint = "ShowBindDefaultPoint",
  ChangePwd = "ShowChangePwd",
  WithdrawEnter = "ShowWithdrawEnter",
  Profile = "ShowProfile",
  EditProfile = "ShowEditProfile",
  WalletVideo = "ShowWalletVideo",
  DepositProgress = "ShowDepositProgress",
  RepeatOrders = "ShowRepeatOrders",
  DepositOrderDetails = "ShowDepositOrderDetails",
  SpeedUpDeposits = "ShowSpeedUpDeposits",
  PendingBillFlow = "ShowPendingBillFlow",
  DetailsRules = "ShowDetailsRules",
  OrderDetail = "ShowOrderDetail",
  DepositPayment = "ShowDepositPayment",
  RetainPopup = "ShowRetainPopup",
  Minors18Popup = "ShowMinors18Popup",
  EmailSucceed = "ShowEmailSucceed",
  NoCode = "ShowNoCode",
  BankCard = "ShowBankCard",
  BankCardAdd = "ShowBankCardAdd",
  // 面部辨识
  FacialRecognition = "ShowFacialRecognition",
  AmountCode = "ShowAmountCode",
  SignOut = "ShowSignOut",
  Share = "ShowShare",
  // 下载app活动
  AppDownloadActivity = "ShowAppDownloadActivity",
  // 系统与运营弹窗
  SystemAndClient = "ShowSystemAndClient",
  // 道具弹窗
  Reward = "showReward",
  // 投注详情-历史投注
  HistoryPopup = "showHistoryPopup",
  VipLevelUp = "ShowVipLevelUp",
  VipActRules = "ShowVipActRules",
  H5RulePopup = "ShowH5RulePopup",

  // 奖金中心 - 普通兑换规则
  RedeemRules = "ShowRedeemRules",
  // 奖金中心 - 可兑换积分说明
  WagerProfitRules = "ShowWagerProfitRules",
  // 奖金中心 - 特色奖金弹窗 - Special Bonus
  SpecialBonus = "ShowSpecialBonus",
  // 奖金中心 - 奖金详情
  BonusDetail = "ShowBonusDetail",
  // 奖金中心 - 奖金详情 - 所有奖金
  BonusDetailAllReward = "BonusDetailAllReward",
  // 扭蛋
  GachaActivity = "showGachaActivity",
  // 任务弹窗
  TaskList = "showTaskList",
  // 扭蛋卡片奖励
  GachaRewards = "showGachaRewards",
  // FreeReliefPC = "ShowFreeReliefPC",
  // FreeReliefH5 = "ShowFreeReliefH5",
  // 救济金
  FreeRelief = "ShowFreeRelief",
  // 新人转盘
  NewbieWheel = "ShowNewbieWheel",
  // 新人礼包 超值礼盒
  SuperValueGift = "ShowSuperValueGift",
  // 新人礼包 超值礼盒 倒计时
  CountDown = "ShowCountDown",
  // 道具列表
  PropsList = "ShowPropsList",
  // 道具列表-免费游戏
  FreeGame = "ShowFreeGame",
  // 道具列表-vip经验
  VipExperience = "ShowVipExperience",
  // RulesDailog = "ShowRulesDailog",
  // 新人7日签到
  NewCheckIn = "ShowNewCheckIn",
  // 新人7日签到-条件不足提示
  NewCheckInTip = "ShowNewCheckInTip",
  // 新人7日签到-道具详情
  NewCheckInPropsTip = "ShowNewCheckInPropsTip",
  // 充值
  Deposit = "ShowDeposit",
  // 奖励中心卡片Rule
  Rule = "ShowRule",
  // 提现
  Withdraw = "ShowWithdraw",
  // 全局搜索
  Search = "ShowSearch",
  // 检查身份 ( 註冊 / kyc / 負責任博彩)
  CheckIdentity = "showCheckIdentity",
  // 检查身份 ( 註冊 / kyc / 負責任博彩)
  KYC = "showKYC",
  // KYC iframe
  KycIframe = "showKycIframe",
  // SEO 组件弹窗
  Seo = "ShowSeo",
  // Activity Iframe
  ActivityIframe = "showActivityIframe",
  // deposit iframe
  DepositIframe = "showDepositIframe",
  // 安装app引导
  InstallAppGuide = "showInstallAppGuide",
  // 提现 - 客服支持KYC
  WithdrawLiveSupportKyc = "showWithdrawLiveSupportKyc",
  // 提现 - 验证提示
  VerifyTipPopup = "showVerifyTipPopup",
  // 锦标赛详情
  TournamentDetail = "showTournamentDetail",
  // 活动轮播图弹窗
  ActivityCarousel = "showActivityCarousel",
}

// 通用的 Dialog 组件 Props 接口
export interface DialogProps {
  dialogData?: unknown;
  zIndex?: number;
}
